import {
  ORG_TYPE as BASE_ORG_TYPE,
  DISTRICT_GROUP_TYPES,
} from '@edulastic/constants/const/roleType'

/** Custom-report access grains — extends shared ORG_TYPE without mutating roleType. */
export const ORG_TYPE = {
  ...BASE_ORG_TYPE,
  STATE: DISTRICT_GROUP_TYPES.STATE,
  DISTRICT_GROUP: 'district-group',
  SCHOOL: 'school',
  ROLE: 'role',
}

export const ORG_TYPE_LABEL = {
  [ORG_TYPE.DISTRICT]: 'District',
  [ORG_TYPE.DISTRICT_GROUP]: 'District Group',
  [ORG_TYPE.STATE]: 'State',
  [ORG_TYPE.SCHOOL]: 'School',
  [ORG_TYPE.ROLE]: 'Roles',
  [ORG_TYPE.USER]: 'Users',
}

export const ORG_SEARCH_OPTION = {
  NAME: 'name',
  ID: 'id',
  DISTRICT_GROUP_ID: 'districtGroupId',
}
